import { Input } from "@/components/ui/input";
import { Field, useFieldError } from "@/shared/forms/Field";
import type * as React from "react";
import { useFormContext } from "react-hook-form";

type FormInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  name: string;
  label?: React.ReactNode;
  hint?: React.ReactNode;
  requiredMark?: boolean;
};

export function FormInput({
  name,
  label,
  hint,
  requiredMark,
  ...rest
}: FormInputProps) {
  const { register } = useFormContext();
  const error = useFieldError(name);

  return (
    <Field name={name} label={label} hint={hint} requiredMark={requiredMark}>
      <Input id={name} aria-invalid={!!error} {...register(name)} {...rest} />
    </Field>
  );
}
